import { useIbanXSBanksCountriesPivotActions } from "features/openBanking/actions";
import { useOpenBankingResource } from "../shared/OpenBankingResource";

export default function useIbanXSBanksCountriesPivot() {
    const { onRowClick } = useOpenBankingResource();

    const {
        getIbanXSBanksCountriesPivot: getResource,
        downloadCsv
    } = useIbanXSBanksCountriesPivotActions();

    return {
        downloadCsv,
        getResource,
        onRowClick
    };
};
